import gql from 'graphql-tag';

export const add = gql`mutation CreateClientContact($contact: ClientContactInput!) {
    createClientContact(contact: $contact) {
        id
        name
        phone
        mobile
        fax
        email
        mainContact
    }
}`;

export const edit = gql`mutation EditClientContact($id: ID!, $contact: ClientContactInput!) {
    editClientContact(id: $id, contact: $contact) {
        id
        name
        phone
        mobile
        fax
        email
        isArchived
        mainContact
    }
}`;


export const remove = gql`mutation RemoveClientContact($id: ID!) {
    removeClientContact(id: $id) {
        id
        name
        phone
        mobile
        fax
        email
        isArchived
        mainContact
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/clientContact.js